import { hot } from 'react-hot-loader/root';
import React from 'react';
import { css } from '@emotion/core';
import PageSection from '../design-system/PageSection';
import FingerprintBannerPageSection from '../design-system/FingerprintBannerPageSection';
import PageWrapper from '../design-system/PageWrapper';
import { Divider } from '../design-system/Dividers';
import { Button, LinkButton, ToggleButton } from '../design-system/Buttons';
import { TabBar, TabItem } from '../design-system/TabBar';
import Paragraph from '../design-system/Paragraph';
import {
  HeadingHero,
  HeadingArticle,
  HeadingSection,
  HeadingPara,
  HeadingSub,
  HeadingLabel,
  HeadingDossier,
} from '../design-system/Headings';
import scssVars from '../design-system/scss-vars';
import MagazineSpread from '../design-system/MagazineSpread';
import { ListItem, UnorderedList } from '../design-system/Lists';
import { ResponsiveImage } from '../design-system/Images';
import DashboardImageCard from '../design-system/cards/DashboardImageCard';
import LaserBannerPageSection from '../design-system/LaserBannerPageSection';
import RadarHeroPageSection from '../design-system/RadarHeroPageSection';
import IconPageSection from '../design-system/IconPageSection';
import Container from '../design-system/Containers';

const ipsum = `Lorem ipsum dolor sit amet, consectetur
adipiscing elit, sed do eiusmod tempor incididunt ut labore
et dolore magna aliqua. Ut enim ad minim veniam, quis
nostrud exercitation ullamco laboris nisi ut aliquip ex ea
commodo consequat.`;

const PLACEHOLDER_IMG = '//images.ctfassets.net/gtqjh9j40j4m/vYLJepx3KSp9SdADc8WqE/f3b215f8403fa3be7f4e05aa69890cfd/spychology-role-hacker-image-1_2x.jpg';

const DesignSystemPage = () => (
  <PageWrapper bgDark>
    <PageSection pyXs>
      <HeadingLabel gray>Spyscape Design System Demo - React</HeadingLabel>
      <Paragraph>
        <a href="html">HTML demo</a>
        {' - '}
        <a href="react">React demo</a>
      </Paragraph>
    </PageSection>
    <PageSection pyXs>
      <HeadingLabel gray>Headings</HeadingLabel>
      <HeadingHero>H1 Lorem - Hero</HeadingHero>
      <HeadingArticle>H2 Lorem - Article</HeadingArticle>
      <HeadingSection>H3 Lorem - Section</HeadingSection>
      <HeadingPara>H4 Lorem - Para</HeadingPara>
      <HeadingSub>H5 Lorem - Sub</HeadingSub>
      <HeadingLabel>H6 Lorem - Label</HeadingLabel>
    </PageSection>
    <PageSection pyXs>
      <HeadingLabel gray>Aliased Headings</HeadingLabel>
      <HeadingPara el="h2">HeadingPara with H2 element</HeadingPara>
      <HeadingLabel el="h3">HeadingLabel with H3 element</HeadingLabel>
    </PageSection>
    <PageSection pyXs>
      <HeadingLabel gray>Paragraphs</HeadingLabel>
      <Paragraph headlineFeature>{`Headline Feature ${ipsum}`}</Paragraph>
      <Paragraph headline>{`Headline ${ipsum}`}</Paragraph>
      <Paragraph intro>{`Intro ${ipsum}`}</Paragraph>
      <Paragraph body>{`Body ${ipsum}`}</Paragraph>
      <Paragraph strongSub>{`Strong Sub ${ipsum}`}</Paragraph>
      <Paragraph sub>{`Sub ${ipsum}`}</Paragraph>
    </PageSection>
    <PageSection pyXs>
      <HeadingLabel gray>
        Lists
      </HeadingLabel>
      <UnorderedList>
        <ListItem>Lorem Ipsum</ListItem>
        <ListItem>{ipsum}</ListItem>
        <ListItem>Lorem Ipsum</ListItem>
      </UnorderedList>
    </PageSection>
    <PageSection pyXs>
      <HeadingLabel gray>Dividers</HeadingLabel>
      <Divider />
    </PageSection>
    <PageSection pyXs>
      <HeadingLabel gray>Buttons</HeadingLabel>
      <Button>Primary Button</Button>
      <Button secondary>Secondary Button</Button>
      <Button round>Rounded Button</Button>
      <Button round active>Rounded Button - Active</Button>
    </PageSection>
    <PageSection pyXs>
      <HeadingLabel gray>Link Buttons</HeadingLabel>
      <LinkButton href="https://www.spyscape.com">Primary Button</LinkButton>
      <LinkButton href="https://www.spyscape.com" secondary>Secondary Button</LinkButton>
      <LinkButton href="https://www.spyscape.com" round>Rounded Button</LinkButton>
      <LinkButton href="https://www.spyscape.com" round active>Rounded Button - Active</LinkButton>
    </PageSection>
    <PageSection pyXs>
      <ResponsiveImage
        src="//images.ctfassets.net/gtqjh9j40j4m/vYLJepx3KSp9SdADc8WqE/f3b215f8403fa3be7f4e05aa69890cfd/spychology-role-hacker-image-1_2x.jpg"
        alt="The classic photograph of a hacker in a darkened room, wearing a hoody"
      />
    </PageSection>
    <PageSection pyXs>
      <HeadingLabel gray>Tab Bar</HeadingLabel>
      <TabBar>
        <TabItem>Item 1</TabItem>
        <TabItem active>Item 2</TabItem>
        <TabItem>Item 3</TabItem>
      </TabBar>
    </PageSection>
    <PageSection pyXs>
      <HeadingLabel gray>Page Sections & Containers</HeadingLabel>
    </PageSection>
    <PageSection bgDarkMid>
      <HeadingLabel>Standard page section</HeadingLabel>
      <Paragraph>Aligns top left</Paragraph>
    </PageSection>
    <PageSection center>
      <HeadingLabel>Centred page section</HeadingLabel>
      <Paragraph>Vertical and horizontal centered</Paragraph>
    </PageSection>
    <PageSection hero center>
      <HeadingArticle>Hero page section</HeadingArticle>
      <HeadingLabel>Vertical and horizontal centered</HeadingLabel>
    </PageSection>
    <PageSection>
      <HeadingLabel gray>Mixed Content</HeadingLabel>
      <HeadingHero>H1 Lorum Ipsum</HeadingHero>
      <Paragraph headlineFeature>{`Headline Feature ${ipsum}`}</Paragraph>
      <HeadingArticle>H2 Lorum Ipsum</HeadingArticle>
      <Paragraph headline>{`Headline ${ipsum}`}</Paragraph>
      <HeadingSub>H5 Lorum Ipsum</HeadingSub>
      <Paragraph>{`Para body ${ipsum}`}</Paragraph>
      <UnorderedList>
        <ListItem>Lorem Ipsum</ListItem>
        <ListItem>{ipsum}</ListItem>
        <ListItem>Lorem Ipsum</ListItem>
      </UnorderedList>
      <HeadingSub>H5 Lorum Ipsum</HeadingSub>
      <Paragraph>{`Para body ${ipsum}`}</Paragraph>
    </PageSection>
    <PageSection>
      <HeadingLabel gray>Usage with React</HeadingLabel>
      <Paragraph css={css`background-color: ${scssVars.ssWarn}; padding: ${scssVars.ssSpaceXs};`}>
        {'This component uses '}
        <code css={css`color: ${scssVars.ssBright};`}>
          $ss-warn
        </code>
        {' and '}
        <code css={css`color: ${scssVars.ssBright};`}>
          $ss-space-xs
        </code>
        {' defined in '}
        <code css={css`color: ${scssVars.ssBright};`}>
          _vars.scss
        </code>
      </Paragraph>
    </PageSection>
    <PageSection>
      <HeadingLabel gray>Magazine Double-Page Spread</HeadingLabel>
      <MagazineSpread
        imageAlt="Lorum Ipsum"
        image={PLACEHOLDER_IMG}
        imageFirst
      >
        <HeadingPara>Lorum Ipsum</HeadingPara>
        <Paragraph secondary>{ipsum}</Paragraph>
      </MagazineSpread>
      <MagazineSpread
        imageAlt="Dollar Sit"
        paragraph={ipsum}
        image={PLACEHOLDER_IMG}
      >
        <HeadingPara>Lorum Ipsum</HeadingPara>
        <Paragraph secondary>{ipsum}</Paragraph>
      </MagazineSpread>
    </PageSection>
    <PageSection>
      <HeadingLabel gray>Cards</HeadingLabel>
      <DashboardImageCard
        title="Dashboard Image Card"
        image={{
          src: '//images.ctfassets.net/gtqjh9j40j4m/5G5QnnPg8oc22u6M4q8KGc/0e8a8287c9206a33f74f792cea888b8a/SpeciaOps.jpg',
          alt: 'Person in laser tunnel',
          link: '/my-account/scores',
        }}
        footer={{
          buttonText: 'See My Scores',
          buttonLink: '/my-account/scores',
        }}
      />
    </PageSection>
    <PageSection>
      <HeadingLabel gray>Derived (non-core) components</HeadingLabel>
    </PageSection>
    <LaserBannerPageSection>
      <HeadingSection my0>Banner page section (laser)</HeadingSection>
    </LaserBannerPageSection>
    <FingerprintBannerPageSection>
      <HeadingSection my0>Banner page section (fingerprint)</HeadingSection>
    </FingerprintBannerPageSection>
    <RadarHeroPageSection>
      <HeadingArticle>Hero page section (radar)</HeadingArticle>
    </RadarHeroPageSection>

    <IconPageSection>
      <Container dossier>
        <HeadingDossier dark ttNone>Lorem - Dossier</HeadingDossier>
        <Paragraph dossierIntro dark>{`Intro ${ipsum}`}</Paragraph>
        <Paragraph dossierBodyHeavy dark>
          Not interested? Continue
          {' →'}
        </Paragraph>
        <Divider />
        <Button dossierPrimary>Dossier Primary Button</Button>
        <Button dossierSecondary>Dossier Secondary Button</Button>
        <Button dossierPrimary disabled>Dossier Primary Disabled Button</Button>
        <br />
        <ToggleButton dossierPrimary>Toggle</ToggleButton>
        <Divider />
        <Paragraph dossierBody dark>{`Body ${ipsum}`}</Paragraph>
        <Divider />
        <HeadingDossier dark ttNone>Profile Selection</HeadingDossier>
        <Paragraph dossierIntro dark>Choose which profiles to print</Paragraph>
        <Paragraph dossierIntroHeavy dark>Your visit: Aug 25, 2024</Paragraph>
        <Paragraph dossierIntro dark>Bob Bobich</Paragraph>
        <Paragraph dossierBody dark>Ticket Code: 1234ABC</Paragraph>
        <Divider />
        <br />
      </Container>
    </IconPageSection>
  </PageWrapper>
);

export default hot(DesignSystemPage);
